import React, { createContext, useContext, useState, useEffect } from 'react';

const CustomerAuthContext = createContext();

export const useCustomerAuth = () => useContext(CustomerAuthContext);

export const CustomerAuthProvider = ({ children }) => {
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [csrfToken, setCsrfToken] = useState(null);

    const checkAuth = async () => {
        try {
            const BASE_URL = process.env.REACT_APP_API_BASE || 'https://handmade-haven.in';
            const response = await fetch(`${BASE_URL}/api/customer/me.php`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include' // Important for cookies
            });

            if (response.ok) {
                const data = await response.json();
                if (data.ok) {
                    setCustomer(data.customer);
                    if (data.csrf_token) {
                        setCsrfToken(data.csrf_token);
                    }
                } else {
                    setCustomer(null);
                    setCsrfToken(null);
                }
            } else if (response.status === 401) {
                // Not logged in - harmless
                setCustomer(null);
                setCsrfToken(null);
            } else {
                setCustomer(null);
                setCsrfToken(null);
            }
        } catch (error) {
            console.warn('Auth check failed - likely network or config issue', error);
            setCustomer(null);
            setCsrfToken(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    const login = (customerData, token) => {
        setCustomer(customerData);
        if (token) setCsrfToken(token);
    };

    const logout = async () => {
        try {
            const BASE_URL = process.env.REACT_APP_API_BASE || 'https://handmade-haven.in';
            await fetch(`${BASE_URL}/api/customer/logout.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken
                },
                credentials: 'include'
            });
            setCustomer(null);
            setCsrfToken(null);
        } catch (error) {
            console.error('Logout failed', error);
            setCustomer(null);
            setCsrfToken(null);
        }
    };

    const [lastOrderTime, setLastOrderTime] = useState(0);

    const refreshOrders = () => {
        setLastOrderTime(Date.now());
    };

    return (
        <CustomerAuthContext.Provider value={{ customer, loading, login, logout, checkAuth, lastOrderTime, refreshOrders, csrfToken }}>
            {children}
        </CustomerAuthContext.Provider>
    );
};
